// import optionTypesClient from '@/client/options/definition/option-types.client';
// import optionTypes from '@/options/definition/option-types';
// import { baseAtomMapping, baseOrganismMapping, mergeMappings } from '@/options/definition/option-mappings';

/*
|-------------------------------------------------------------------------------
| Your option targets can be defined below (refer to src/options/definition/option-targets.js for syntax)
| Uncomment the needed import above
| See the README in this folder, or the docsify documentation for more information
|-------------------------------------------------------------------------------
*/

export default {
    /*
    |-------------------------------------------------------------------------------
    | Atoms
    |-------------------------------------------------------------------------------
    */

    /*
    |-------------------------------------------------------------------------------
    | Organisms
    |-------------------------------------------------------------------------------
    */

};
